import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
// eslint-disable-next-line 
// @ts-ignore
import firebaseConfig from './.firebaseConfig'

firebase.initializeApp(firebaseConfig)

const database = firebase.database()

export {database}